module.exports = __webpack_public_path__ + "static/media/Lato-HairlineItalic.8f30b438.svg";